import { motion } from "framer-motion";
import { PROFILE } from "@/content";
import { useLanguage } from "@/lang";
import { SectionHeading } from "./SectionHeading";

export const About = () => {
  const { copy } = useLanguage();

  return (
  <section id="ueber" data-testid="about-section" className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-32">
    <SectionHeading {...copy.headings.about} />

    <div className="max-w-3xl">
      {copy.chapters.map((chapter, i) => (
        <motion.div
          key={chapter.nr}
          data-testid={`chapter-${chapter.nr}`}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="grid grid-cols-12 gap-4 md:gap-8 py-10 md:py-14 border-b border-white/10 first:border-t"
        >
          <span className="col-span-2 md:col-span-1 font-display italic text-3xl md:text-4xl text-zinc-600">
            {chapter.nr}
          </span>
          <div className="col-span-10 md:col-span-11">
            <h3 className="font-display text-2xl md:text-3xl tracking-tight mb-4">{chapter.title}</h3>
            <p className="text-sm md:text-base text-zinc-400 leading-relaxed max-w-xl">{chapter.text}</p>
          </div>
        </motion.div>
      ))}
    </div>

    <motion.p
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
      className="mt-16 font-display italic text-2xl md:text-4xl text-zinc-500 max-w-2xl leading-snug"
    >
      {copy.quote.text}
      <span className="block mt-4 text-sm not-italic font-sans uppercase tracking-[0.3em] text-zinc-600">
        — {PROFILE.name}, {copy.quote.source}
      </span>
    </motion.p>
  </section>
  );
};
